// extracted by mini-css-extract-plugin
export default {"privacyMessage":"privacy-message_privacyMessage__08i6L","checkbox":"privacy-message_checkbox__fpT-p"};